import { IWebsiteProviderScorecardConfig, IWebsiteProviderScorecardBillboardConfig } from '../../../../_shared/models/models-index';
import { IMetricType } from '../../../../_shared/enums/enums';


export class WebsiteProviderScorecardConfig implements IWebsiteProviderScorecardConfig {
    public reportTitle: string;
    public scorecardMetrics: IWebsiteProviderScorecardBillboardConfig[];
}
